import React, {useState} from 'react';
import { useParams } from 'react-router-dom';
import careerList from './careers.json';
import PageNotFound from './404';
import { useUserProfile } from './user-profile-context';
import { useNavigate } from 'react-router-dom';
import "../styles/careers.css"

export default function Preview() {
    const { career } = useParams();
    const validCareer = careerList.find(item => item.id === career) || null;
    const {userProfile} = useUserProfile();
    const navigate = useNavigate();

    function handleStart() {
        if (validCareer.isPaid) {
            if (userProfile.isPremium) {
                window.location.href=`/career/${validCareer.id}`
            } else {
                navigate('/payment');
            }
        } else {
            window.location.href=`/career/${validCareer.id}`
        }
        
    }

    return (
        <div>
            {
                !validCareer ? 
                <PageNotFound/> :
                <div style={{background: "antiquewhite", paddingBottom: "50px", minHeight: "calc(100vh - 70px"}}>
                    <div className='preview-page container center' style={{width: "1000px", margin: "auto"}}>
                        <div style={{padding: "20px"}}>
                            <h1 style={{margin: "0"}}>{validCareer.title}</h1>
                        </div>
                        <div className='syllabus-container'>
                            <div className='syllabus-item'>
                                <strong>Syllabus</strong>
                            </div>
                            {
                                validCareer.toc.map((item, index) => (
                                    <div className='syllabus-item row' key={index}>
                                        <div className='counter'>
                                            {index + 1}
                                        </div>
                                        <div className='description'>
                                            <p>{item}</p>
                                        </div>
                                    </div>
                                ))
                                
                            }
                        </div>
                        <div className='center' style={{marginTop: "30px"}}>
                            <button className='primary-btn' onClick={handleStart}>Start</button>
                        </div>

                    </div>
                </div>
            }
        </div>
    )
}